"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    columnType: {
      // 类型
      type: String,
      default: 'span'
    },
    filterList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    align: {
      type: String,
      default: 'center'
    },
    filterValue: {
      type: String,
      default: 'value'
    },
    filterLabel: {
      type: String,
      default: 'label'
    },
    // 若数据字典中没有这个值，则显示原先的值
    noneShowVal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      value: ''
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo', 'tagBgColor'])), {}, {
    tagWidth: function tagWidth() {
      var filterList;
      if (this.$parent.$attrs['filter-list'] !== undefined) {
        filterList = this.$parent.$attrs['filter-list'];
      } else {
        filterList = this.filterList;
      }
      var width = 0;
      var _iterator = (0, _createForOfIteratorHelper2.default)(filterList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (this.filterValue === 'codeValue') {
            if (this.language === 'zh') {
              if (item.displayValueCn && item.displayValueCn.length * 15 > width) {
                width = item.displayValueCn.length * 15;
              }
            } else {
              if (item.displayValue && item.displayValue.length * 6 > width) {
                width = item.displayValue.length * 6;
              }
            }
          } else {
            if (item[this.filterLabel] && item[this.filterLabel].length * 15 > width) {
              width = item[this.filterLabel].length * 15;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return width + 20 + 'px';
    },
    filter: function filter() {
      var filter = {};
      var filterList;
      if (this.$parent.$attrs['filter-list'] !== undefined) {
        filterList = this.$parent.$attrs['filter-list'];
      } else {
        filterList = this.filterList;
      }
      if (this.value !== null) {
        if (this.value.toString().split(',').length > 1) {
          filter.label = '';
          var valList = this.value.toString().split(',');
          for (var i in valList) {
            var _iterator2 = (0, _createForOfIteratorHelper2.default)(filterList),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var item = _step2.value;
                if (JSON.parse(JSON.stringify(item[this.filterValue])).toString() === JSON.parse(JSON.stringify(valList[i])).toString() && item[this.filterValue] !== undefined) {
                  if (this.filterValue === 'codeValue') {
                    filter.label += this.language === 'zh' ? item.displayValueCn : item.displayValue;
                    if (i < valList.length - 1) {
                      filter.label += ',';
                    }
                  } else {
                    filter.label += item[this.filterLabel];
                    if (i < valList.length - 1) {
                      filter.label += ',';
                    }
                  }
                  // filter.type = item['remark2'] || 'default'
                  filter.color = this.tagBgColor[item['remark2']] || this.tagBgColor['Intermediate'];
                  filter.show = true;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } else {
          for (var _i in filterList) {
            if (JSON.parse(JSON.stringify(filterList[_i][this.filterValue])).toString() === JSON.parse(JSON.stringify(typeof this.value === 'boolean' ? Number(this.value) : this.value)).toString() && filterList[_i][this.filterValue] !== undefined) {
              if (this.filterValue === 'codeValue') {
                if (this.filterLabel === 'displayValue') {
                  filter.label = filterList[_i].displayValue;
                } else {
                  filter.label = this.language === 'zh' ? filterList[_i].displayValueCn : filterList[_i].displayValue;
                }
              } else {
                filter.label = filterList[_i][this.filterLabel];
              }
              filter.color = this.tagBgColor[filterList[_i]['remark2']] || this.tagBgColor['Intermediate'];
              filter.show = true;
              break;
            } else if (this.noneShowVal && _i.toString() === (filterList.length - 1).toString()) {
              filter.label = this.value;
              filter.show = true;
            } else {
              this.columnType === 'tag' && this.value === '' && (filter.show = false);
            }
          }
        }
        return filter;
      } else {
        var _filter = {};
        _filter.type = 'default';
        _filter.label = '';
        _filter.show = false;
        return _filter;
      }
    }
  }),
  created: function created() {}
};